import React, { ChangeEvent, useState, useEffect } from 'react';
import i18n from 'i18next';
import { createSpotClasses, Spot } from '../../';
import withFormValidation from '../validation/withFormValidation';
import { SpotSelectBox, SpotSelectOption } from '../SpotSelectBox';
import { DropdownProps, Option } from './interfaces';

import './Dropdown.scss';

function Dropdown({ id, validateData, onChange, label, subLabel, disabled = false, selectProps, initialValue }: DropdownProps) {
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);
  const inputId = `${id}-input`;

  useEffect(() => {
    setSelectedOption(initialValue ? selectProps.options.find((option) => option.value === initialValue) || null : null);
  }, []);

  useEffect(() => {
    validateData(selectedOption);
    onChange(selectedOption);
  }, [selectedOption, onChange, validateData]);

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target;
    setSelectedOption(selectProps.options.find((option) => option.value === value) || null);
  };

  return (
    <div className={'spot-custom-dropdown'}>
      {label && (
        <label className={createSpotClasses(Spot.block.form, Spot.element.label)} htmlFor={inputId}>
          {i18n.t(label)}
        </label>
      )}
      {subLabel && <span className={createSpotClasses(Spot.block.form, Spot.element.microcopy)}>{i18n.t(subLabel)}</span>}
      <SpotSelectBox
        id={inputId}
        value={selectedOption ? selectedOption.value : ''}
        onChange={handleChange}
        disabled={disabled}
        placeholder={selectProps.placeholder}
      >
        {selectProps.options.map((option) => (
          <SpotSelectOption key={option.value} value={option.value}>
            {option.label}
          </SpotSelectOption>
        ))}
      </SpotSelectBox>
    </div>
  );
}

export default withFormValidation(Dropdown);
